// extracted by mini-css-extract-plugin
export default {"mobile":"style_mobile__uoVAQ","img":"style_img__oKPHA","hide":"style_hide__BOBjS","laptop":"style_laptop__JBXHy"};